import React from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Table } from "antd";
import type { TableColumnsType } from 'antd';
import { withWarehouseData, WarehouseDataType as HocWarehouseDataType } from "../../components/hoc_browser_warehouse";
import "./browser_warehouse.css";

interface BrowserWarehouseProps {
    columns: TableColumnsType<HocWarehouseDataType>; // Gunakan tipe dari HOC
    data: HocWarehouseDataType[]; // Gunakan tipe dari HOC
    loading: boolean;
    // Tambahkan definisi prop onRow yang hilang
    onRow: (record: HocWarehouseDataType) => React.HTMLAttributes<HTMLElement>;
}

const BrowserWarehouse: React.FC<BrowserWarehouseProps> = ({ columns, data, loading, onRow }) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="iklk" style={transformStyle}>
            {/* Grid Row 1 */}
            <div className="gjs-grid-row" id="i99e">
                <div className="gjs-grid-column" id="iwmcq">
                    <Breadcrumb
                        items={[
                            {
                                href: "",
                                title: <HomeOutlined />,
                            },
                            {
                                href: "",
                                title: (
                                    <>
                                        <UserOutlined />
                                        <span>Data Warehouse</span>
                                    </>
                                ),
                            },
                            {
                                title: "Warehouse",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="irxd5" style={{ marginTop: '20px' }}> 
                    <div className="gjs-grid-column" id="i19ku">
                        <Table<HocWarehouseDataType>
                            columns={columns}
                            dataSource={data}
                            loading={loading}
                            bordered
                            size="small"
                            scroll={{ x: 1300 }}
                            onRow={onRow}
                        />
                    </div>
                </div>
        </div>
    );
};

export default withWarehouseData(BrowserWarehouse);
